'use client';

import { c as _c } from "react/compiler-runtime";
import queryString from 'query-string';
// This hook is intended for use in Next.js environment only
// and there is a legacy counterpart for this as well
// eslint-disable-next-line import/no-unresolved
import { useRouter, usePathname, useSearchParams } from 'next/navigation';
import { useMemo, useCallback } from 'react';
import { debounce } from 'lodash';
import { ALGOLIA_INDEX_NAME, DEFAULT_SORT_ORDER } from 'commons/constants';
import { CATEGORY_INDEX_MAPPING } from '../../commons/helpers';
const normalizeCategoryParam = raw => CATEGORY_INDEX_MAPPING[raw] || raw || ALGOLIA_INDEX_NAME.PRODUCTS;
const useAdvancedSearchNextURL = () => {
  const $ = _c(21);
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  let t0;
  if ($[0] !== searchParams) {
    const rawCategoryParam = searchParams?.get("category") ?? ALGOLIA_INDEX_NAME.PRODUCTS;
    t0 = normalizeCategoryParam(rawCategoryParam);
    $[0] = searchParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const categoryUrlParam = t0;
  let t1;
  if ($[2] !== searchParams) {
    t1 = searchParams?.get("q") ?? "";
    $[2] = searchParams;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const queryUrlParam = t1;
  let t2;
  if ($[4] !== searchParams) {
    t2 = searchParams?.get("sortBy") ?? DEFAULT_SORT_ORDER;
    $[4] = searchParams;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const sortByUrlParam = t2;
  let t3;
  if ($[6] !== pathname || $[7] !== router || $[8] !== searchParams) {
    t3 = debounce(updates => {
      if (updates) {
        const prev = Object.fromEntries(searchParams);
        const merged = {
          ...prev,
          ...updates
        };
        const updatedUrlParams = queryString.stringify(merged);
        const newPath = `${pathname}${!pathname.endsWith("/") ? "/" : ""}?${updatedUrlParams}`;
        router.replace(newPath, {
          scroll: false
        });
      }
    }, 500);
    $[6] = pathname;
    $[7] = router;
    $[8] = searchParams;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const debouncedUpdateUrlParam = t3;
  let t4;
  if ($[10] !== pathname || $[11] !== router || $[12] !== searchParams) {
    t4 = updates_0 => {
      if (updates_0) {
        const prev_0 = Object.fromEntries(searchParams);
        const merged_0 = {
          ...prev_0,
          ...updates_0
        };
        const updatedUrlParams_0 = queryString.stringify(merged_0);
        const newPath_0 = `${pathname}${!pathname.endsWith("/") ? "/" : ""}?${updatedUrlParams_0}`;
        router.replace(newPath_0, {
          scroll: false
        });
      }
    };
    $[10] = pathname;
    $[11] = router;
    $[12] = searchParams;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  const updateUrlParamImmediate = t4;
  let t5;
  if ($[14] !== categoryUrlParam || $[15] !== debouncedUpdateUrlParam || $[16] !== pathname || $[17] !== queryUrlParam || $[18] !== sortByUrlParam || $[19] !== updateUrlParamImmediate) {
    t5 = {
      pathname,
      queryUrlParam,
      categoryUrlParam,
      sortByUrlParam,
      updateUrlParam: debouncedUpdateUrlParam,
      updateUrlParamImmediate
    };
    $[14] = categoryUrlParam;
    $[15] = debouncedUpdateUrlParam;
    $[16] = pathname;
    $[17] = queryUrlParam;
    $[18] = sortByUrlParam;
    $[19] = updateUrlParamImmediate;
    $[20] = t5;
  } else {
    t5 = $[20];
  }
  return t5;
};
export default useAdvancedSearchNextURL;